package com.schoolconnect.app.feature.students

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.CircularProgressIndicator
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.IntRect
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.window.Popup
import androidx.compose.ui.window.PopupPositionProvider
import androidx.compose.ui.window.PopupProperties
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogColors
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogFormGrid
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogStandardWidth
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogValidationSummary
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.designsystem.AppSearchableDropdownField
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppInfoBg
import com.schoolconnect.app.designsystem.AppInfoBorder
import com.schoolconnect.app.designsystem.AppInfoText
import com.schoolconnect.app.designsystem.AppLine
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.list.AdminListDefaults
import com.schoolconnect.app.designsystem.list.AdminListFilterBanner
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListPagination
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListRowAction
import com.schoolconnect.app.designsystem.list.AdminListRowActionBar
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListToolbar
import com.schoolconnect.app.designsystem.list.AdminListToolbarButton
import com.schoolconnect.app.feature.common.compareBySmartText
import com.schoolconnect.app.feature.common.buildClassSectionFilterChoices
import com.schoolconnect.app.feature.common.selectedClassSectionFilterLabel
import com.schoolconnect.app.feature.common.compareDateFilter
import com.schoolconnect.app.feature.common.toWindow
import com.schoolconnect.app.designsystem.list.AdminStandardRowActionMenu
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import com.schoolconnect.app.domain.SchoolKeys
import com.schoolconnect.app.repository.systemlookup.SystemLookupRepository
import com.schoolconnect.app.repository.systemlookup.SystemLookupOptions
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.pencil
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.search
import ischoolconnect.sharedui.generated.resources.trash
import ischoolconnect.sharedui.generated.resources.users
import org.jetbrains.compose.resources.painterResource
import kotlin.math.max
import kotlin.math.min
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.distinctUntilChanged

internal val StudentsBackground = AppBackground
internal val StudentsSurface = AppSurface
internal val StudentsBorder = AppBorder
internal val StudentsNavy = AppNavy
internal val StudentsMuted = AppMuted
internal val StudentsPrimary = AppPrimary
internal val StudentsPrimarySoft = AppPrimarySoft
internal val StudentsSuccess = AppSuccess
internal val StudentsSuccessSoft = AppSuccessSoft
internal val StudentsDanger = AppDanger
internal val StudentsDangerSoft = AppDangerSoft
internal val StudentsWarning = Color(0xFFF59E0B)
internal val StudentsWarningSoft = Color(0xFFFFF1E0)
internal val StudentsLine = AppLine
internal val StudentsInfoBg = AppInfoBg
internal val StudentsInfoBorder = AppInfoBorder
internal val StudentsInfoText = AppInfoText

private val StudentsDialogColors = com.schoolconnect.app.designsystem.AppDialogDefaultColors


data class StudentSubjectOption(
    val code: String,
    val label: String
)

internal fun studentSubjectOptions(): List<StudentSubjectOption> = listOf(
    StudentSubjectOption("MAT", "MAT - Mathematics"),
    StudentSubjectOption("SCI", "SCI - Science"),
    StudentSubjectOption("ENG", "ENG - English"),
    StudentSubjectOption("SST", "SST - Social Science"),
    StudentSubjectOption("HIN", "HIN - Hindi"),
    StudentSubjectOption("COMP", "COMP - Computer Science"),
    StudentSubjectOption("GK", "GK - General Knowledge"),
    StudentSubjectOption("ART", "ART - Art")
)

internal fun studentGenderLabel(value: String): String {
    SystemLookupOptions.label("GENDER", value).takeIf { it.isNotBlank() && it != value.trim() }?.let { return it }
    val normalized = value.trim().lowercase()
    return when (normalized) {
        SchoolKeys.V_GENDER_F, "f", "female" -> "Female"
        SchoolKeys.V_GENDER_M, "m", "male" -> "Male"
        "other" -> "Other"
        else -> "-"
    }
}

internal fun studentBloodGroupLabel(code: String): String {
    val serverLabel = SystemLookupOptions.label("BLOOD_GROUP", code)
    return studentBloodGroupExcelLabel(code, serverLabel).ifBlank { "-" }
}

private fun studentBloodGroupExcelLabel(code: String, serverLabel: String): String {
    val normalizedCode = code.trim().uppercase()
    val normalizedLabel = serverLabel.trim().uppercase()
    return when (normalizedCode) {
        SchoolKeys.V_BLOOD_GROUP_A_POS -> "A+"
        SchoolKeys.V_BLOOD_GROUP_A_NEG -> "A-"
        SchoolKeys.V_BLOOD_GROUP_B_POS -> "B+"
        SchoolKeys.V_BLOOD_GROUP_B_NEG -> "B-"
        SchoolKeys.V_BLOOD_GROUP_AB_POS -> "AB+"
        SchoolKeys.V_BLOOD_GROUP_AB_NEG -> "AB-"
        SchoolKeys.V_BLOOD_GROUP_O_POS -> "O+"
        SchoolKeys.V_BLOOD_GROUP_O_NEG -> "O-"
        "A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-" -> normalizedCode
        else -> when (normalizedLabel) {
            "A POSITIVE" -> "A+"
            "A NEGATIVE" -> "A-"
            "B POSITIVE" -> "B+"
            "B NEGATIVE" -> "B-"
            "AB POSITIVE" -> "AB+"
            "AB NEGATIVE" -> "AB-"
            "O POSITIVE" -> "O+"
            "O NEGATIVE" -> "O-"
            else -> serverLabel.trim().takeIf { it.isNotBlank() && !it.equals(code.trim(), ignoreCase = true) }
                ?: code.trim().takeIf { it.isNotBlank() }.orEmpty()
        }
    }
}

@Composable
private fun rememberStudentLookupOptions(category: String): List<Pair<String, String>> {
    var options by remember(category) { mutableStateOf(emptyList<Pair<String, String>>()) }
    LaunchedEffect(category) {
        options = SystemLookupRepository.loadCategoryItems(category)
            .getOrDefault(emptyList())
            .mapNotNull { item ->
                val code = item.code?.trim().orEmpty()
                val lookupLabel = item.displayValue?.trim().takeUnless { it.isNullOrBlank() } ?: code
                val label = if (category.equals("BLOOD_GROUP", ignoreCase = true)) {
                    studentBloodGroupExcelLabel(code, lookupLabel)
                } else {
                    lookupLabel
                }
                code.takeIf { it.isNotBlank() }?.let { it to label }
            }
            .distinctBy { it.first.uppercase() }
    }
    return options
}

internal fun studentStatusLabel(code: String): String = when (code) {
    SchoolKeys.V_STATUS_ACTIVE -> "Active"
    SchoolKeys.V_STATUS_INACTIVE -> "Inactive"
    else -> "-"
}

internal fun studentRelationLabel(code: String): String = when (code) {
    SchoolKeys.V_REL_FATHER -> "Father"
    SchoolKeys.V_REL_MOTHER -> "Mother"
    SchoolKeys.V_REL_GUARDIAN -> "Guardian"
    "Father", "father" -> "Father"
    "Mother", "mother" -> "Mother"
    "Guardian", "guardian" -> "Guardian"
    else -> "-"
}

internal fun studentFilterLabels(filters: StudentFilterValues): List<String> = buildList {
    if (filters.className.isNotBlank()) add("Class: ${filters.className.trim()}")
    if (filters.section.isNotBlank()) add("Section: ${filters.section.trim()}")
    if (filters.genderCode.isNotBlank()) add("Gender: ${studentGenderLabel(filters.genderCode)}")
    if (filters.statusCode.isNotBlank()) add("Status: ${studentStatusLabel(filters.statusCode)}")
    if (filters.bloodGroupCode.isNotBlank()) add("Blood group: ${studentBloodGroupLabel(filters.bloodGroupCode)}")
    if (filters.subjectCodes.isNotEmpty()) add("Subjects: ${filters.subjectCodes.joinToString(", ")}")
    if (filters.createdFrom.isNotBlank() || filters.createdTo.isNotBlank()) {
        val from = filters.createdFrom.ifBlank { "Any" }
        val to = filters.createdTo.ifBlank { "Any" }
        add("Created: $from to $to")
    }
}

internal fun studentFormValuesFromRow(row: StudentRowUi): StudentFormValues = StudentFormValues(
    id = row.id,
    admissionNo = row.admissionNo,
    studentName = row.studentName,
    className = row.className,
    section = row.section,
    rollNo = row.rollNo,
    genderCode = row.genderCode,
    dob = row.dateOfBirth,
    bloodGroupCode = row.bloodGroupCode,
    subjectCodes = row.subjectCodes,
    statusCode = row.statusCode
)

internal fun studentsPage(state: StudentsUiState): StudentsPageUi {
    val pageItems = state.students

    val window = state.paging.toWindow(pageItems.size)

    return StudentsPageUi(
        items = pageItems,
        totalCount = window.totalCount,
        startIndex = window.startIndex,
        endIndex = window.endIndex,
        pageCount = window.pageCount
    )
}

internal fun studentStatusColors(code: String): Pair<Color, Color> =
    if (code == SchoolKeys.V_STATUS_ACTIVE) StudentsSuccess to StudentsSuccessSoft else StudentsDanger to StudentsDangerSoft

@Composable
internal fun studentStatusBadge(
    code: String,
    modifier: Modifier = Modifier
) {
    val (accent, _) = studentStatusColors(code)
    AdminListTableBodyText(
        text = studentStatusLabel(code),
        color = accent,
        modifier = modifier
    )
}

@Composable
internal fun StudentsScreenScaffold(
    state: StudentsUiState,
    onEvent: (StudentsUiEvent) -> Unit,
    headerActions: @Composable RowScope.() -> Unit = {},
    onAddClicked: () -> Unit,
    onFilterClicked: () -> Unit,
    pageIndex: Int,
    pageSize: Int,
    rowsPerPageExpanded: Boolean,
    onRowsPerPageToggle: () -> Unit,
    onRowsPerPageDismiss: () -> Unit,
    onPageSizeChanged: (Int) -> Unit,
    onPageChanged: (Int) -> Unit,
    onEditStudent: (StudentRowUi) -> Unit,
    onViewStudent: (StudentRowUi) -> Unit,
    onToggleStudent: (StudentRowUi) -> Unit,
    onDeleteStudent: (StudentRowUi) -> Unit,
    suppressMessageBanner: Boolean = false
) {
    val page = remember(state.students, state.paging, state.sortField, state.sortAscending) {
        studentsPage(state)
    }
    AdminListPageScaffold(
        title = "Manage Students",
        subtitle = "Create, update and manage student records.",
        backgroundColor = StudentsBackground,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        headerActions = headerActions,
        summaryCards = {},
        showSummaryCards = false,
        bannerAfterToolbar = true,
        banner = {
            val filters = studentFilterLabels(state.filters)
            if (!suppressMessageBanner) {
                if (state.errorMessage.isNotBlank() || state.infoMessage.isNotBlank()) {
                    StudentMessageBanner(
                        message = state.errorMessage.ifBlank { state.infoMessage },
                        isError = state.errorMessage.isNotBlank(),
                        onDismiss = { onEvent(StudentsUiEvent.ClearMessages) }
                    )
                }
                AdminListFilterBanner(
                    chips = filters,
                    onClearAll = { onEvent(StudentsUiEvent.FiltersReset) },
                    onRemoveChip = { chip ->
                        val next = when {
                            chip.startsWith("Class:") -> state.filters.copy(className = "")
                            chip.startsWith("Section:") -> state.filters.copy(section = "")
                            chip.startsWith("Gender:") -> state.filters.copy(genderCode = "")
                            chip.startsWith("Status:") -> state.filters.copy(statusCode = "")
                            chip.startsWith("Blood group:") -> state.filters.copy(bloodGroupCode = "")
                            chip.startsWith("Subjects:") -> state.filters.copy(subjectCodes = emptyList())
                            chip.startsWith("Created:") -> state.filters.copy(createdFrom = "", createdTo = "")
                            else -> state.filters
                        }
                        onEvent(StudentsUiEvent.FiltersApplied(state.searchQuery, next))
                    },
                    onEditFilters = onFilterClicked,
                    backgroundColor = Color(0xFFF2F7FF),
                    borderColor = StudentsInfoBorder,
                    contentColor = StudentsNavy,
                    accentColor = StudentsPrimary
                )
            }
        },
        toolbar = {
            AdminListToolbar(
                searchQuery = state.searchQuery,
                onSearchQueryChanged = { onEvent(StudentsUiEvent.SearchChanged(it)) },
                searchPlaceholder = "Search by admission no, student name or roll number...",
                searchWidth = 320.dp,
                surfaceColor = StudentsSurface,
                borderColor = StudentsBorder,
                searchIconTint = StudentsMuted,
                searchTextColor = StudentsNavy,
                searchCursorColor = StudentsPrimary,
                inlineContent = {
                    val classSectionChoices = remember(
                        state.studentFilterClassOptions,
                        state.studentFilterSectionOptions,
                        state.studentFilterSectionsByClass
                    ) {
                        buildClassSectionFilterChoices(
                            classNames = state.studentFilterClassOptions,
                            sectionsByClass = state.studentFilterSectionsByClass
                        )
                    }
                    AppSearchableDropdownField(
                        label = "",
                        value = selectedClassSectionFilterLabel(
                            state.filters.className,
                            state.filters.section,
                            classSectionChoices
                        ),
                        placeholder = "Select Class / Section",
                        options = classSectionChoices.map { it.label },
                        onValueChange = { choiceLabel ->
                            val choice = classSectionChoices.firstOrNull { it.label == choiceLabel }
                            onEvent(
                                StudentsUiEvent.FiltersApplied(
                                    state.searchQuery,
                                    state.filters.copy(
                                        className = choice?.className.orEmpty(),
                                        section = choice?.sectionName.orEmpty()
                                    )
                                )
                            )
                        },
                        modifier = Modifier.width(240.dp),
                        valueFontWeight = androidx.compose.ui.text.font.FontWeight.Normal,
                        maxMenuHeight = 320.dp
                    )
                    val genderOptions = rememberStudentLookupOptions("GENDER")
                    AppLabeledDropdownField(
                        label = "",
                        value = state.filters.genderCode
                            .takeIf { it.isNotBlank() }
                            ?.let(::studentGenderLabel)
                            .orEmpty()
                            .ifBlank { "All Genders" },
                        options = genderOptions.map { it.second },
                        onSelected = { gender ->
                            val code = genderOptions.firstOrNull { it.second == gender }?.first.orEmpty()
                            onEvent(
                                StudentsUiEvent.FiltersApplied(
                                    state.searchQuery,
                                    state.filters.copy(genderCode = code)
                                )
                            )
                        },
                        modifier = Modifier.width(136.dp),
                        allOptionLabel = "All Genders",
                        enabled = genderOptions.isNotEmpty()
                    )
                    val statusOptions = listOf(
                        SchoolKeys.V_STATUS_ACTIVE to studentStatusLabel(SchoolKeys.V_STATUS_ACTIVE),
                        SchoolKeys.V_STATUS_INACTIVE to studentStatusLabel(SchoolKeys.V_STATUS_INACTIVE)
                    )
                    AppLabeledDropdownField(
                        label = "",
                        value = state.filters.statusCode
                            .takeIf { it.isNotBlank() }
                            ?.let(::studentStatusLabel)
                            .orEmpty()
                            .ifBlank { "All Statuses" },
                        options = statusOptions.map { it.second },
                        onSelected = { status ->
                            val code = statusOptions.firstOrNull { it.second == status }?.first.orEmpty()
                            onEvent(
                                StudentsUiEvent.FiltersApplied(
                                    state.searchQuery,
                                    state.filters.copy(statusCode = code)
                                )
                            )
                        },
                        modifier = Modifier.width(136.dp),
                        allOptionLabel = "All Statuses"
                    )
                }
            ) {
                AdminListToolbarButton(
                    label = "More Filters",
                    icon = painterResource(Res.drawable.filter),
                    onClick = onFilterClicked,
                    width = 148.dp,
                    borderColor = StudentsBorder,
                    contentColor = StudentsPrimary
                )
                AdminListToolbarButton(
                    label = "Clear",
                    icon = painterResource(Res.drawable.close_x),
                    onClick = { onEvent(StudentsUiEvent.FiltersReset) },
                    width = 100.dp,
                    borderColor = StudentsBorder,
                    contentColor = StudentsPrimary
                )
            }
        },
        table = { tableModifier ->
            StudentsTableCard(
                modifier = tableModifier,
                isLoading = state.isLoading,
                sortField = state.sortField,
                sortAscending = state.sortAscending,
                page = page,
                onSortChanged = { onEvent(StudentsUiEvent.SortChanged(it)) },
                onEditStudent = onEditStudent,
                onViewStudent = onViewStudent,
                onToggleStudent = onToggleStudent,
                onDeleteStudent = onDeleteStudent,
                pageIndex = pageIndex,
                pageSize = pageSize,
                rowsPerPageExpanded = rowsPerPageExpanded,
                onRowsPerPageToggle = onRowsPerPageToggle,
                onRowsPerPageDismiss = onRowsPerPageDismiss,
                onPageSizeChanged = onPageSizeChanged,
                onPageChanged = onPageChanged
            )
        },
        bottomAction = {
            AdminListPrimaryActionButton(
                label = "Add Student",
                icon = painterResource(Res.drawable.plus),
                onClick = onAddClicked,
                backgroundColor = StudentsPrimary
            )
        }
    )
}

@Composable
private fun StudentsTableCard(
    modifier: Modifier = Modifier,
    isLoading: Boolean,
    sortField: StudentSortField,
    sortAscending: Boolean,
    page: StudentsPageUi,
    onSortChanged: (StudentSortField) -> Unit,
    onEditStudent: (StudentRowUi) -> Unit,
    onViewStudent: (StudentRowUi) -> Unit,
    onToggleStudent: (StudentRowUi) -> Unit,
    onDeleteStudent: (StudentRowUi) -> Unit,
    pageIndex: Int,
    pageSize: Int,
    rowsPerPageExpanded: Boolean,
    onRowsPerPageToggle: () -> Unit,
    onRowsPerPageDismiss: () -> Unit,
    onPageSizeChanged: (Int) -> Unit,
    onPageChanged: (Int) -> Unit
) {
    AdminListTableCard(
        modifier = modifier.fillMaxSize(),
        surfaceColor = StudentsSurface,
        borderColor = StudentsBorder,
        minContentWidth = 860.dp,
        header = {
            AdminListSortHeaderRow(
                columns = listOf(
                    AdminListSortColumn(
                        label = "Admission No.",
                        weight = 1.05f,
                        selected = sortField == StudentSortField.ADMISSION_NO,
                        ascending = sortAscending,
                        onClick = { onSortChanged(StudentSortField.ADMISSION_NO) }
                    ),
                    AdminListSortColumn(
                        label = "Student Name",
                        weight = 1.35f,
                        selected = sortField == StudentSortField.STUDENT_NAME,
                        ascending = sortAscending,
                        onClick = { onSortChanged(StudentSortField.STUDENT_NAME) }
                    ),
                    AdminListSortColumn(
                        label = "Class",
                        weight = 0.6f,
                        selected = sortField == StudentSortField.CLASS,
                        ascending = sortAscending,
                        onClick = { onSortChanged(StudentSortField.CLASS) }
                    ),
                    AdminListSortColumn(
                        label = "Section",
                        weight = 0.7f,
                        selected = sortField == StudentSortField.SECTION,
                        ascending = sortAscending,
                        onClick = { onSortChanged(StudentSortField.SECTION) }
                    ),
                    AdminListSortColumn(
                        label = "Roll No.",
                        weight = 0.75f,
                        selected = sortField == StudentSortField.ROLL_NO,
                        ascending = sortAscending,
                        onClick = { onSortChanged(StudentSortField.ROLL_NO) }
                    ),
                    AdminListSortColumn(
                        label = "Gender",
                        weight = 0.85f,
                        selected = sortField == StudentSortField.GENDER,
                        ascending = sortAscending,
                        onClick = { onSortChanged(StudentSortField.GENDER) }
                    ),
                    AdminListSortColumn(
                        label = "Status",
                        weight = 0.82f,
                        selected = sortField == StudentSortField.STATUS,
                        ascending = sortAscending,
                        onClick = { onSortChanged(StudentSortField.STATUS) }
                    )
                ),
                actionsLabel = "Actions",
                actionsWeight = 0.95f,
                actionsAlignment = Alignment.Center,
                height = 44.dp,
                horizontalPadding = 24.dp,
                labelColor = StudentsNavy,
                selectedColor = StudentsPrimary,
                unselectedColor = StudentsMuted
            )
        },
        body = {
            if (isLoading) {
                AdminListTableShimmer(
                    columns = studentsTableShimmerColumns(),
                    rowCount = pageSize.coerceAtLeast(5),
                    modifier = Modifier.fillMaxWidth()
                )
            } else if (page.items.isEmpty()) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = "No students found",
                        color = StudentsNavy,
                        fontWeight = FontWeight.ExtraBold
                    )
                }
            } else {
                AdminListTableBody(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f),
                    items = page.items,
                    key = { it.id }
                ) { student ->
                    StudentTableRow(
                        student = student,
                        onEditStudent = { onEditStudent(student) },
                        onViewStudent = { onViewStudent(student) },
                        onToggleStudent = { onToggleStudent(student) },
                        onDeleteStudent = { onDeleteStudent(student) }
                    )
                    if (student.id != page.items.lastOrNull()?.id) {
                        HorizontalDivider(color = StudentsLine)
                    }
                }
            }
        },
        footer = {
            AdminListFooter(
                pageText = if (page.totalCount == 0) {
                    "Showing 0 to 0 of 0 students"
                } else {
                    "Showing ${page.startIndex} to ${page.endIndex} of ${page.totalCount} students"
                },
                pageIndex = pageIndex,
                pageCount = page.pageCount,
                onPageChanged = onPageChanged,
                pageSize = pageSize,
                rowsPerPageExpanded = rowsPerPageExpanded,
                onRowsPerPageToggle = onRowsPerPageToggle,
                onRowsPerPageDismiss = onRowsPerPageDismiss,
                onPageSizeChanged = onPageSizeChanged
            )
        }
    )
}

private fun studentsTableShimmerColumns(): List<AdminListHeaderColumn> = listOf(
    AdminListHeaderColumn(label = "Admission No.", weight = 1.05f),
    AdminListHeaderColumn(label = "Student Name", weight = 1.35f),
    AdminListHeaderColumn(label = "Class", weight = 0.6f),
    AdminListHeaderColumn(label = "Section", weight = 0.7f),
    AdminListHeaderColumn(label = "Roll No.", weight = 0.75f),
    AdminListHeaderColumn(label = "Gender", weight = 0.85f),
    AdminListHeaderColumn(label = "Status", weight = 0.82f),
    AdminListHeaderColumn(label = "Actions", weight = 0.95f, alignCenter = true)
)

@Composable
private fun StudentTableRow(
    student: StudentRowUi,
    onEditStudent: () -> Unit,
    onViewStudent: () -> Unit,
    onToggleStudent: () -> Unit,
    onDeleteStudent: () -> Unit
) {
    var actionMenuExpanded by remember { mutableStateOf(false) }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .onViewDoubleClick(onViewStudent)
            .heightIn(min = 52.dp)
            .padding(horizontal = 24.dp, vertical = 10.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        StudentTableCell(student.admissionNo, 1.05f)
        StudentTableCell(student.studentName, 1.35f)
        StudentTableCell(student.className, 0.6f)
        StudentTableCell(student.section, 0.7f)
        StudentTableCell(student.rollNo, 0.75f)
        StudentTableCell(studentGenderLabel(student.genderCode), 0.85f)

        Box(modifier = Modifier.weight(0.82f)) {
            studentStatusBadge(student.statusCode)
        }

        Box(
            modifier = Modifier.weight(0.95f),
            contentAlignment = Alignment.Center
        ) {
            AdminListRowActionBar(
                    isActive = student.statusCode == SchoolKeys.V_STATUS_ACTIVE,
                    expanded = actionMenuExpanded,
                    onExpandedChange = { actionMenuExpanded = it },
                    onDismissRequest = { actionMenuExpanded = false },
                    onView = {
                        actionMenuExpanded = false
                        onViewStudent()
                    },
                    onEdit = {
                        actionMenuExpanded = false
                        onEditStudent()
                    },
                    onToggleStatus = {
                        actionMenuExpanded = false
                        onToggleStudent()
                    },
                    onDelete = {
                        actionMenuExpanded = false
                        onDeleteStudent()
                    },
                    width = 190.dp,
                    surfaceColor = AdminListDefaults.Surface,
                    borderColor = AdminListDefaults.Border
            )
        }
    }
}

@Composable
private fun RowScope.StudentTableCell(
    text: String,
    weight: Float
) {
    Box(
        modifier = Modifier
            .weight(weight)
            .padding(end = 8.dp)
    ) {
        AdminListTableBodyText(
            text = text,
            color = StudentsNavy,
            fontWeight = FontWeight.SemiBold
        )
    }
}

@Composable
internal fun StudentsFilterBanner(
    text: String,
    onClear: () -> Unit,
    modifier: Modifier = Modifier
) {
    AdminListFilterBanner(
        chips = listOf(text),
        onClearAll = onClear,
        onRemoveChip = { onClear() },
        modifier = modifier,
        backgroundColor = StudentsInfoBg,
        borderColor = StudentsInfoBorder,
        contentColor = StudentsInfoText,
        accentColor = StudentsInfoText
    )
}

@Composable
internal fun StudentMessageBanner(
    message: String,
    isError: Boolean,
    onDismiss: () -> Unit
) {
    val background = if (isError) StudentsDangerSoft else StudentsInfoBg
    val border = if (isError) StudentsDanger.copy(alpha = 0.35f) else StudentsInfoBorder
    val textColor = if (isError) StudentsDanger else StudentsInfoText
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(background, RoundedCornerShape(10.dp))
            .border(1.dp, border, RoundedCornerShape(10.dp))
            .padding(horizontal = 16.dp, vertical = 12.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = message,
            color = textColor,
            fontSize = 13.sp,
            fontWeight = FontWeight.SemiBold
        )
        Text(
            text = "Dismiss",
            color = textColor,
            fontSize = 13.sp,
            fontWeight = FontWeight.ExtraBold,
            modifier = Modifier.clickable(onClick = onDismiss)
        )
    }
}

@Composable
internal fun StudentViewModal(
    student: StudentRowUi,
    onClose: () -> Unit,
    title: String = "View Student"
) {
    AppDialogScaffold(
        onDismiss = onClose,
        size = AppDialogSize.Standard,
        colors = StudentsDialogColors,
        maxDialogHeight = 900.dp
    ) {
        AppDialogFormGrid(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            contentAlignment = Alignment.Center,
            compactBreakpoint = 820.dp
        ) {
            val compact = it
            val scrollState = rememberScrollState()

            Column(modifier = Modifier.fillMaxWidth()) {
                StudentViewHeader(student = student, title = title, onClose = onClose)
                HorizontalDivider(color = StudentsBorder)
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f, fill = false)
                        .verticalScroll(scrollState)
                        .padding(horizontal = 28.dp, vertical = 24.dp),
                    verticalArrangement = Arrangement.spacedBy(if (compact) 18.dp else 22.dp)
                ) {
                    StudentMetaCard(student = student)
                    StudentSectionCard(title = "Student Information") {
                        StudentDetailRow("Admission No.", student.admissionNo)
                        StudentDetailRow("Student Name", student.studentName)
                        StudentDetailRow("Class", student.className)
                        StudentDetailRow("Section", student.section)
                        StudentDetailRow("Roll No.", student.rollNo)
                        StudentDetailRow("Gender", studentGenderLabel(student.genderCode))
                        StudentDetailRow("Date of Birth", student.dateOfBirth)
                        StudentDetailRow("Blood Group", studentBloodGroupLabel(student.bloodGroupCode))
                        StudentDetailRow("Subject Codes", student.subjectCodes.joinToString(", "))
                        StudentDetailRow(
                            "Status",
                            "",
                            valueContent = { studentStatusBadge(student.statusCode) }
                        )
                    }
                    StudentSectionCard(title = "Parent / Guardian Information") {
                        StudentGuardianSection("Primary Contact", student.primaryGuardian)
                        HorizontalDivider(color = StudentsLine, modifier = Modifier.padding(vertical = 14.dp))
                        StudentGuardianSection("Secondary Contact", student.secondaryGuardian)
                    }
                }
                HorizontalDivider(color = StudentsBorder)
                AppDialogFooter(
                    actions = listOf(
                        AppDialogFooterAction(label = "Close", onClick = onClose, width = 108.dp)
                    ),
                    colors = StudentsDialogColors,
                    contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 24.dp)
                )
            }
        }
    }
}

@Composable
private fun StudentViewHeader(
    student: StudentRowUi,
    title: String,
    onClose: () -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = 28.dp, end = 20.dp, top = 24.dp, bottom = 14.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.Top
    ) {
        Row(horizontalArrangement = Arrangement.spacedBy(20.dp), verticalAlignment = Alignment.Top) {
            Box(
                modifier = Modifier
                    .size(44.dp)
                    .background(StudentsPrimarySoft, RoundedCornerShape(10.dp)),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = painterResource(Res.drawable.eye),
                    contentDescription = null,
                    tint = StudentsPrimary,
                    modifier = Modifier.size(24.dp)
                )
            }
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Text(
                    text = title,
                    style = MaterialTheme.typography.headlineSmall,
                    color = StudentsNavy,
                    fontWeight = FontWeight.Bold
                )
                Text(
                    text = student.studentName,
                    style = MaterialTheme.typography.bodyMedium,
                    color = StudentsMuted,
                    fontWeight = FontWeight.Medium
                )
            }
        }
        IconButton(onClick = onClose) {
            Icon(
                painter = painterResource(Res.drawable.close_x),
                contentDescription = "Close",
                tint = StudentsNavy
            )
        }
    }
}

@Composable
private fun StudentMetaCard(
    student: StudentRowUi
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = Color(0xFFFBFCFF)),
        border = androidx.compose.foundation.BorderStroke(1.dp, StudentsBorder)
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            Row(horizontalArrangement = Arrangement.spacedBy(24.dp), verticalAlignment = Alignment.CenterVertically) {
                StudentMetaLine("Created By:", student.createdBy, Res.drawable.users, Modifier.weight(1f))
                StudentMetaLine("Created Date:", student.createdAtText, Res.drawable.calendar, Modifier.weight(1f))
            }
            Row(horizontalArrangement = Arrangement.spacedBy(24.dp), verticalAlignment = Alignment.CenterVertically) {
                StudentMetaLine("Updated By:", student.updatedBy, Res.drawable.users, Modifier.weight(1f))
                StudentMetaLine("Updated Date:", student.updatedAtText, Res.drawable.calendar, Modifier.weight(1f))
            }
        }
    }
}

@Composable
private fun StudentMetaLine(
    label: String,
    value: String,
    icon: org.jetbrains.compose.resources.DrawableResource,
    modifier: Modifier = Modifier
) {
    Row(modifier = modifier, verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(16.dp)) {
        Box(
            modifier = Modifier
                .size(42.dp)
                .background(StudentsPrimarySoft, RoundedCornerShape(21.dp)),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = painterResource(icon),
                contentDescription = null,
                tint = StudentsPrimary,
                modifier = Modifier.size(22.dp)
            )
        }
        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Text(
                text = label,
                color = StudentsMuted,
                fontWeight = FontWeight.SemiBold,
                fontSize = 14.sp
            )
            Text(
                text = value.ifBlank { "-" },
                color = StudentsNavy,
                fontWeight = FontWeight.Medium,
                fontSize = 14.sp,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
private fun StudentSectionCard(
    title: String,
    content: @Composable ColumnScope.() -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = StudentsSurface),
        border = androidx.compose.foundation.BorderStroke(1.dp, StudentsBorder)
    ) {
        Column(modifier = Modifier.fillMaxWidth().padding(18.dp)) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Box(
                    modifier = Modifier
                        .size(34.dp)
                        .background(StudentsPrimarySoft, RoundedCornerShape(8.dp)),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.users),
                        contentDescription = null,
                        tint = StudentsPrimary,
                        modifier = Modifier.size(18.dp)
                    )
                }
                Text(
                    text = title,
                    color = StudentsPrimary,
                    fontWeight = FontWeight.Bold,
                    fontSize = 14.sp
                )
            }
            HorizontalDivider(color = StudentsLine, modifier = Modifier.padding(vertical = 14.dp))
            content()
        }
    }
}

@Composable
private fun StudentDetailRow(
    label: String,
    value: String,
    valueContent: @Composable () -> Unit = {
        Text(
            text = value,
            color = StudentsNavy,
            fontWeight = FontWeight.SemiBold,
            fontSize = 13.sp
        )
    }
) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(vertical = 7.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = label,
            modifier = Modifier.width(170.dp),
            color = StudentsMuted,
            fontSize = 13.sp,
            fontWeight = FontWeight.SemiBold
        )
        Text(text = ":", color = StudentsMuted, fontWeight = FontWeight.SemiBold)
        Spacer(modifier = Modifier.width(12.dp))
        valueContent()
    }
}

@Composable
private fun StudentGuardianSection(
    label: String,
    guardian: StudentGuardianUi
) {
    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
        Text(
            text = label,
            color = StudentsNavy,
            fontWeight = FontWeight.Bold,
            fontSize = 13.sp
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(10.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = guardian.name,
                color = StudentsNavy,
                fontWeight = FontWeight.Medium,
                fontSize = 13.sp
            )
            Text(text = "|", color = StudentsMuted)
            Text(
                text = studentRelationLabel(guardian.relationCode),
                color = StudentsNavy,
                fontWeight = FontWeight.Medium,
                fontSize = 13.sp
            )
            Text(text = "|", color = StudentsMuted)
            Text(
                text = guardian.mobile,
                color = StudentsNavy,
                fontWeight = FontWeight.Medium,
                fontSize = 13.sp
            )
            Text(text = "|", color = StudentsMuted)
            Text(
                text = guardian.email,
                color = StudentsNavy,
                fontWeight = FontWeight.Medium,
                fontSize = 13.sp,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
internal fun StudentFormModal(
    open: Boolean,
    title: String,
    subtitle: String,
    initialValues: StudentFormValues,
    showStatusField: Boolean,
    subjectOptions: List<StudentSubjectOption> = emptyList(),
    classSectionOptions: List<StudentClassSectionOption> = emptyList(),
    classSectionPicker: StudentClassSectionPickerUi = StudentClassSectionPickerUi(),
    onClassSectionSearchChanged: (String) -> Unit = {},
    onClassSectionPageChanged: (Int) -> Unit = {},
    onClassSectionLoadMore: () -> Unit = {},
    onClassSectionOpened: () -> Unit = {},
    isSaving: Boolean = false,
    apiError: String = "",
    onClose: () -> Unit,
    onSave: (StudentFormValues) -> Unit,
    saveLabel: String
) {
    if (!open) return

    var values by remember(initialValues) { mutableStateOf(initialValues) }
    var hasSubmitted by remember { mutableStateOf(showStatusField) }
    var classExpanded by remember { mutableStateOf(false) }
    var sectionExpanded by remember { mutableStateOf(false) }
    var genderExpanded by remember { mutableStateOf(false) }
    var bloodGroupExpanded by remember { mutableStateOf(false) }
    var statusExpanded by remember { mutableStateOf(false) }

    val errors = remember(hasSubmitted, values) {
        if (hasSubmitted) validateStudent(values) else StudentFormErrors()
    }

    LaunchedEffect(open, initialValues) {
        if (open) {
            values = initialValues
            hasSubmitted = showStatusField
            classExpanded = false
            sectionExpanded = false
            genderExpanded = false
            bloodGroupExpanded = false
            statusExpanded = false
        }
    }

    AppDialogScaffold(
        onDismiss = { if (!isSaving) onClose() },
        dismissOnClickOutside = false,
        size = AppDialogSize.Standard,
        colors = StudentsDialogColors,
        maxDialogHeight = 900.dp,
        isLoading = isSaving,
        loadingTitle = if (showStatusField) "Saving student" else "Adding student"
    ) {
        AppDialogFormGrid(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            contentAlignment = Alignment.Center,
            compactBreakpoint = 900.dp
        ) {
            val compact = it
            val scrollState = rememberScrollState()

            Column(modifier = Modifier.fillMaxWidth()) {
                StudentFormHeader(title = title, subtitle = subtitle, onClose = { if (!isSaving) onClose() })
                AppDialogValidationSummary(
                    errors = listOf(
                        errors.admissionNo,
                        errors.studentName,
                        errors.className,
                        errors.section,
                        errors.rollNo,
                        errors.genderCode,
                        errors.dob,
                        errors.bloodGroupCode,
                        errors.subjectCodes,
                        if (showStatusField) errors.statusCode else ""
                    ),
                    colors = StudentsDialogColors,
                    modifier = Modifier.padding(horizontal = 28.dp, vertical = 12.dp)
                )
                AppDialogErrorMessage(
                    message = apiError,
                    colors = StudentsDialogColors,
                    modifier = Modifier.padding(horizontal = 28.dp, vertical = 12.dp)
                )
                HorizontalDivider(color = StudentsBorder)

                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f, fill = false)
                        .verticalScroll(scrollState)
                        .padding(horizontal = if (compact) 24.dp else 28.dp, vertical = 24.dp),
                    verticalArrangement = Arrangement.spacedBy(if (compact) 20.dp else 24.dp)
                ) {
                    if (compact) {
                        StudentFormBody(
                            values = values,
                            errors = errors,
                            showStatusField = showStatusField,
                            onValuesChange = { values = it },
                            subjectOptions = subjectOptions,
                            classSectionOptions = classSectionOptions,
                            classSectionPicker = classSectionPicker,
                            onClassSectionSearchChanged = onClassSectionSearchChanged,
                            onClassSectionPageChanged = onClassSectionPageChanged,
                            onClassSectionLoadMore = onClassSectionLoadMore,
                            onClassSectionOpened = onClassSectionOpened,
                            onClassToggle = { classExpanded = !classExpanded },
                            classExpanded = classExpanded,
                            onClassDismiss = { classExpanded = false },
                            onSectionToggle = { sectionExpanded = !sectionExpanded },
                            sectionExpanded = sectionExpanded,
                            onSectionDismiss = { sectionExpanded = false },
                            onGenderToggle = { genderExpanded = !genderExpanded },
                            genderExpanded = genderExpanded,
                            onGenderDismiss = { genderExpanded = false },
                            onBloodGroupToggle = { bloodGroupExpanded = !bloodGroupExpanded },
                            bloodGroupExpanded = bloodGroupExpanded,
                            onBloodGroupDismiss = { bloodGroupExpanded = false },
                            onStatusToggle = { statusExpanded = !statusExpanded },
                            statusExpanded = statusExpanded,
                            onStatusDismiss = { statusExpanded = false }
                        )
                    } else {
                        StudentFormBody(
                            values = values,
                            errors = errors,
                            showStatusField = showStatusField,
                            onValuesChange = { values = it },
                            subjectOptions = subjectOptions,
                            classSectionOptions = classSectionOptions,
                            classSectionPicker = classSectionPicker,
                            onClassSectionSearchChanged = onClassSectionSearchChanged,
                            onClassSectionPageChanged = onClassSectionPageChanged,
                            onClassSectionLoadMore = onClassSectionLoadMore,
                            onClassSectionOpened = onClassSectionOpened,
                            onClassToggle = { classExpanded = !classExpanded },
                            classExpanded = classExpanded,
                            onClassDismiss = { classExpanded = false },
                            onSectionToggle = { sectionExpanded = !sectionExpanded },
                            sectionExpanded = sectionExpanded,
                            onSectionDismiss = { sectionExpanded = false },
                            onGenderToggle = { genderExpanded = !genderExpanded },
                            genderExpanded = genderExpanded,
                            onGenderDismiss = { genderExpanded = false },
                            onBloodGroupToggle = { bloodGroupExpanded = !bloodGroupExpanded },
                            bloodGroupExpanded = bloodGroupExpanded,
                            onBloodGroupDismiss = { bloodGroupExpanded = false },
                            onStatusToggle = { statusExpanded = !statusExpanded },
                            statusExpanded = statusExpanded,
                            onStatusDismiss = { statusExpanded = false }
                        )
                    }
                }

                HorizontalDivider(color = StudentsBorder)

                AppDialogFooter(
                    actions = listOf(
                        AppDialogFooterAction(
                            label = "Cancel",
                            onClick = { if (!isSaving) onClose() },
                            enabled = !isSaving,
                            width = 108.dp
                        ),
                        AppDialogFooterAction(
                            label = if (isSaving) {
                                if (showStatusField) "Saving..." else "Adding..."
                            } else saveLabel,
                            onClick = {
                                if (!isSaving) {
                                    hasSubmitted = true
                                    val currentErrors = validateStudent(values)
                                    val canSave = listOf(
                                        currentErrors.admissionNo,
                                        currentErrors.studentName,
                                        currentErrors.className,
                                        currentErrors.section,
                                        currentErrors.rollNo,
                                        currentErrors.genderCode,
                                        currentErrors.dob,
                                        currentErrors.bloodGroupCode,
                                        currentErrors.subjectCodes,
                                        if (showStatusField) currentErrors.statusCode else ""
                                    ).all { it.isBlank() }
                                    if (canSave) {
                                        onSave(
                                            values.copy(
                                                statusCode = values.statusCode.ifBlank { SchoolKeys.V_STATUS_ACTIVE }
                                            )
                                        )
                                    }
                                }
                            },
                            style = AppDialogActionStyle.Primary,
                            enabled = !isSaving,
                            width = 108.dp
                        )
                    ),
                    colors = StudentsDialogColors,
                    contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 24.dp)
                )
            }
        }
    }
}

@Composable
private fun StudentFormHeader(
    title: String,
    subtitle: String,
    onClose: () -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = 28.dp, end = 20.dp, top = 24.dp, bottom = 14.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.Top
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Text(
                text = title,
                style = MaterialTheme.typography.headlineSmall,
                color = StudentsNavy,
                fontWeight = FontWeight.Bold
            )
            Text(
                text = subtitle,
                style = MaterialTheme.typography.bodyMedium,
                color = StudentsMuted,
                fontWeight = FontWeight.Medium
            )
        }
        IconButton(onClick = onClose) {
            Icon(
                painter = painterResource(Res.drawable.close_x),
                contentDescription = "Close",
                tint = StudentsNavy
            )
        }
    }
}

@Composable
private fun StudentFormBody(
    values: StudentFormValues,
    errors: StudentFormErrors,
    showStatusField: Boolean,
    onValuesChange: (StudentFormValues) -> Unit,
    subjectOptions: List<StudentSubjectOption>,
    classSectionOptions: List<StudentClassSectionOption>,
    classSectionPicker: StudentClassSectionPickerUi,
    onClassSectionSearchChanged: (String) -> Unit,
    onClassSectionPageChanged: (Int) -> Unit,
    onClassSectionLoadMore: () -> Unit,
    onClassSectionOpened: () -> Unit,
    onClassToggle: () -> Unit,
    classExpanded: Boolean,
    onClassDismiss: () -> Unit,
    onSectionToggle: () -> Unit,
    sectionExpanded: Boolean,
    onSectionDismiss: () -> Unit,
    onGenderToggle: () -> Unit,
    genderExpanded: Boolean,
    onGenderDismiss: () -> Unit,
    onBloodGroupToggle: () -> Unit,
    bloodGroupExpanded: Boolean,
    onBloodGroupDismiss: () -> Unit,
    onStatusToggle: () -> Unit,
    statusExpanded: Boolean,
    onStatusDismiss: () -> Unit
) {
    val selectedPickerOption = classSectionPicker.options.firstOrNull {
        it.className.equals(values.className, ignoreCase = true) &&
            it.sectionName.equals(values.section, ignoreCase = true)
    }
    val selectedSectionSubjects = (selectedPickerOption?.subjectCodes ?: classSectionOptions
        .firstOrNull {
            it.className.equals(values.className, ignoreCase = true) &&
                it.sectionName.equals(values.section, ignoreCase = true)
        }
        ?.subjectCodes)
        .orEmpty()
        .map { it.uppercase() }
        .toSet()
    val availableSubjectOptions = selectedSectionSubjects.map { code ->
        subjectOptions.firstOrNull { it.code.equals(code, ignoreCase = true) }
            ?: StudentSubjectOption(code, code)
    }
    val genderOptions = rememberStudentLookupOptions("GENDER")
    val bloodGroupOptions = rememberStudentLookupOptions("BLOOD_GROUP")
    val statusOptions = listOf(
        SchoolKeys.V_STATUS_ACTIVE to "Active",
        SchoolKeys.V_STATUS_INACTIVE to "Inactive"
    )

    Column(verticalArrangement = Arrangement.spacedBy(22.dp)) {
        Row(horizontalArrangement = Arrangement.spacedBy(28.dp)) {
            StudentFieldColumn(
                label = "Admission No.",
                required = true,
                error = errors.admissionNo,
                modifier = Modifier.weight(1f)
            ) {
                StudentTextField(
                    value = values.admissionNo,
                    onValueChange = { onValuesChange(values.copy(admissionNo = it)) },
                    placeholder = "Enter admission number",
                    error = errors.admissionNo
                )
            }
            StudentFieldColumn(
                label = "Student Name",
                required = true,
                error = errors.studentName,
                modifier = Modifier.weight(1f)
            ) {
                StudentTextField(
                    value = values.studentName,
                    onValueChange = { onValuesChange(values.copy(studentName = it)) },
                    placeholder = "Enter student name",
                    error = errors.studentName
                )
            }
        }

        Row(horizontalArrangement = Arrangement.spacedBy(28.dp), verticalAlignment = Alignment.Top) {
            StudentFieldColumn(
                label = "Class & Section",
                required = true,
                error = errors.className.ifBlank { errors.section },
                modifier = Modifier.weight(2f)
            ) {
                StudentClassSectionPickerField(
                    value = values.className.takeIf { it.isNotBlank() }?.let { "$it - ${values.section}" }.orEmpty(),
                    picker = classSectionPicker,
                    expanded = classExpanded,
                    onToggleExpanded = onClassToggle,
                    onDismissExpanded = onClassDismiss,
                    onSearchChanged = onClassSectionSearchChanged,
                    onPageChanged = onClassSectionPageChanged,
                    onLoadMore = onClassSectionLoadMore,
                    onOpened = onClassSectionOpened,
                    onSelected = { option ->
                        onValuesChange(
                            values.copy(
                                className = option.className,
                                section = option.sectionName,
                                classSectionId = option.id,
                                subjectCodes = emptyList()
                            )
                        )
                    },
                    error = errors.className.ifBlank { errors.section }
                )
            }
            StudentFieldColumn(
                label = "Roll No.",
                required = true,
                error = errors.rollNo,
                modifier = Modifier.weight(1f)
            ) {
                StudentTextField(
                    value = values.rollNo,
                    onValueChange = { onValuesChange(values.copy(rollNo = it)) },
                    placeholder = "Enter roll number",
                    error = errors.rollNo
                )
            }
        }

        Row(horizontalArrangement = Arrangement.spacedBy(20.dp), verticalAlignment = Alignment.Top) {
            StudentFieldColumn(
                label = "Gender",
                required = true,
                error = errors.genderCode,
                modifier = Modifier.weight(1f)
            ) {
                StudentDropdownField(
                    value = values.genderCode.takeIf { it.isNotBlank() }?.let(::studentGenderLabel).orEmpty(),
                    placeholder = "Select gender",
                    expanded = genderExpanded,
                    options = genderOptions.map { it.second },
                    onToggleExpanded = onGenderToggle,
                    onDismissExpanded = onGenderDismiss,
                    onSelected = { selected ->
                        val code = genderOptions.firstOrNull { it.second == selected }?.first.orEmpty()
                        onValuesChange(values.copy(genderCode = code))
                    },
                    error = errors.genderCode
                )
            }
            StudentFieldColumn(
                label = "Date of Birth",
                required = true,
                error = errors.dob,
                modifier = Modifier.weight(1f)
            ) {
                AppDialogDateField(
                    value = values.dob,
                    onValueChange = { onValuesChange(values.copy(dob = it)) },
                    placeholder = "DD MMM YYYY",
                    error = errors.dob,
                    colors = StudentsDialogColors,
                    fieldHeight = 54.dp,
                    fontSize = 14.sp
                )
            }
            StudentFieldColumn(
                label = "Blood Group",
                required = true,
                error = errors.bloodGroupCode,
                modifier = Modifier.weight(1f)
            ) {
                StudentDropdownField(
                    value = values.bloodGroupCode.takeIf { it.isNotBlank() }?.let(::studentBloodGroupLabel).orEmpty(),
                    placeholder = "Select blood group",
                    expanded = bloodGroupExpanded,
                    options = bloodGroupOptions.map { it.second },
                    onToggleExpanded = onBloodGroupToggle,
                    onDismissExpanded = onBloodGroupDismiss,
                    onSelected = { selected ->
                        val code = bloodGroupOptions.firstOrNull { it.second == selected }?.first.orEmpty()
                        onValuesChange(values.copy(bloodGroupCode = code))
                    },
                    error = errors.bloodGroupCode
                )
            }
        }

        StudentFieldColumn(
            label = "Subject Codes",
            required = true,
            error = errors.subjectCodes
        ) {
            StudentSubjectMultiSelectField(
                selectedCodes = values.subjectCodes,
                subjectOptions = availableSubjectOptions,
                onSelectedCodesChange = { onValuesChange(values.copy(subjectCodes = it)) },
                error = errors.subjectCodes
            )
        }

        if (showStatusField) {
            StudentFieldColumn(
                label = "Status",
                required = true,
                error = errors.statusCode,
                modifier = Modifier.width(500.dp)
            ) {
                StudentDropdownField(
                    value = studentStatusLabel(values.statusCode),
                    placeholder = "Select status",
                    expanded = statusExpanded,
                    options = statusOptions.map { it.second },
                    onToggleExpanded = onStatusToggle,
                    onDismissExpanded = onStatusDismiss,
                    onSelected = { selected ->
                        val code = statusOptions.firstOrNull { it.second == selected }?.first ?: SchoolKeys.V_STATUS_ACTIVE
                        onValuesChange(values.copy(statusCode = code))
                    },
                    error = errors.statusCode
                )
            }
        }
    }
}

@Composable
private fun StudentFieldColumn(
    label: String,
    required: Boolean,
    error: String,
    modifier: Modifier = Modifier,
    content: @Composable ColumnScope.() -> Unit
) {
    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(10.dp)
    ) {
        Text(
            text = buildAnnotatedString {
                append(label)
                if (required) {
                    append(" ")
                    withStyle(SpanStyle(color = StudentsDanger)) { append("*") }
                }
            },
            color = StudentsNavy,
            fontSize = 14.sp,
            fontWeight = FontWeight.Bold
        )
        content()
        if (error.isNotBlank()) {
            Text(
                text = error,
                color = StudentsDanger,
                fontSize = 12.sp,
                fontWeight = FontWeight.Medium
            )
        }
    }
}

@Composable
private fun StudentTextField(
    value: String,
    onValueChange: (String) -> Unit,
    placeholder: String,
    modifier: Modifier = Modifier,
    trailingIcon: (@Composable () -> Unit)? = null,
    error: String = ""
) {
    Surface(
        modifier = modifier
            .fillMaxWidth()
            .height(54.dp),
        shape = RoundedCornerShape(8.dp),
        color = StudentsSurface,
        border = androidx.compose.foundation.BorderStroke(
            1.dp,
            if (error.isNotBlank()) StudentsDanger else StudentsBorder
        )
    ) {
        Row(
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = 16.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            BasicTextField(
                value = value,
                onValueChange = onValueChange,
                modifier = Modifier.weight(1f),
                textStyle = TextStyle(
                    fontSize = 14.sp,
                    color = StudentsNavy,
                    fontWeight = FontWeight.Medium
                ),
                singleLine = true,
                cursorBrush = SolidColor(com.schoolconnect.app.designsystem.AppPrimary)
            ) { inner ->
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.CenterStart) {
                    if (value.isBlank()) {
                        Text(
                            text = placeholder,
                            color = StudentsMuted,
                            fontSize = 14.sp,
                            fontWeight = FontWeight.Medium
                        )
                    }
                    inner()
                }
            }
            trailingIcon?.invoke()
        }
    }
}

@Composable
private fun StudentDropdownField(
    value: String,
    placeholder: String,
    expanded: Boolean,
    options: List<String>,
    onToggleExpanded: () -> Unit,
    onDismissExpanded: () -> Unit,
    onSelected: (String) -> Unit,
    modifier: Modifier = Modifier,
    error: String = ""
) {
    var anchorSize by remember { mutableStateOf(IntSize.Zero) }
    val anchorWidth = with(LocalDensity.current) { anchorSize.width.toDp() }
    Box(
        modifier = modifier
            .fillMaxWidth()
            .onGloballyPositioned { anchorSize = it.size }
    ) {
        Surface(
            modifier = Modifier
                .fillMaxWidth()
                .height(54.dp)
                .clickable(onClick = onToggleExpanded),
            shape = RoundedCornerShape(8.dp),
            color = StudentsSurface,
            border = androidx.compose.foundation.BorderStroke(
                1.dp,
                if (error.isNotBlank()) StudentsDanger else StudentsBorder
            )
        ) {
            Row(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(horizontal = 16.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Text(
                    text = value.ifBlank { placeholder },
                    color = if (value.isBlank()) StudentsMuted else StudentsNavy,
                    fontSize = 14.sp,
                    fontWeight = FontWeight.Medium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Icon(
                    painter = painterResource(Res.drawable.chevron_down),
                    contentDescription = null,
                    tint = StudentsNavy
                )
            }
        }
        AppDropdownMenu(
            expanded = expanded,
            onDismissRequest = onDismissExpanded,
            containerColor = StudentsSurface,
            width = anchorWidth.takeIf { it > 0.dp }
        ) {
            options.forEach { option ->
                DropdownMenuItem(
                    text = { Text(option) },
                    onClick = {
                        onSelected(option)
                        onDismissExpanded()
                    }
                )
            }
        }
    }
}

@Composable
private fun StudentClassSectionPickerField(
    value: String,
    picker: StudentClassSectionPickerUi,
    expanded: Boolean,
    onToggleExpanded: () -> Unit,
    onDismissExpanded: () -> Unit,
    onSearchChanged: (String) -> Unit,
    onPageChanged: (Int) -> Unit,
    onLoadMore: () -> Unit,
    onOpened: () -> Unit,
    onSelected: (StudentClassSectionOption) -> Unit,
    error: String = ""
) {
    var searchQuery by remember { mutableStateOf("") }
    var anchorSize by remember { mutableStateOf(IntSize.Zero) }
    val listState = rememberLazyListState()
    val popupWidth = with(LocalDensity.current) { anchorSize.width.toDp() }
    LaunchedEffect(expanded, picker.options.size, picker.isLoadingMore, picker.hasMore) {
        if (expanded) {
            snapshotFlow { listState.layoutInfo.visibleItemsInfo.lastOrNull()?.index ?: -1 }
                .distinctUntilChanged()
                .collectLatest { lastVisible ->
                    if (picker.hasMore && !picker.isLoading && !picker.isLoadingMore && picker.options.isNotEmpty() && lastVisible >= picker.options.lastIndex - 1) {
                        onLoadMore()
                    }
                }
        }
    }
    Box(modifier = Modifier.onGloballyPositioned { anchorSize = it.size }) {
        Surface(
            modifier = Modifier.fillMaxWidth().height(58.dp).clickable {
                if (!expanded) onOpened()
                onToggleExpanded()
            },
            shape = RoundedCornerShape(8.dp),
            color = StudentsSurface,
            border = androidx.compose.foundation.BorderStroke(1.dp, if (expanded) StudentsPrimary else if (error.isNotBlank()) StudentsDanger else StudentsBorder)
        ) {
            Row(
                modifier = Modifier.fillMaxSize().padding(horizontal = 16.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Text(
                    text = value.ifBlank { "Select class and section" },
                    color = if (value.isBlank()) StudentsMuted else StudentsNavy,
                    fontSize = 14.sp,
                    fontWeight = FontWeight.Medium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Icon(painter = painterResource(Res.drawable.chevron_down), contentDescription = null, tint = StudentsPrimary)
            }
        }
        if (expanded) {
            Popup(
                popupPositionProvider = classSectionDropdownPopupPositionProvider(),
                properties = PopupProperties(focusable = true, dismissOnBackPress = true, dismissOnClickOutside = true),
                onDismissRequest = onDismissExpanded
            ) {
                Surface(
                    modifier = Modifier.width(popupWidth),
                    shape = RoundedCornerShape(8.dp),
                    color = StudentsSurface,
                    shadowElevation = 8.dp
                ) {
                    Column {
                        Row(
                            modifier = Modifier.fillMaxWidth().height(54.dp).padding(horizontal = 18.dp),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(10.dp)
                        ) {
                            Icon(painterResource(Res.drawable.search), contentDescription = null, tint = StudentsMuted, modifier = Modifier.size(22.dp))
                            BasicTextField(
                                value = searchQuery,
                                onValueChange = { searchQuery = it; onSearchChanged(it) },
                                singleLine = true,
                                textStyle = TextStyle(fontSize = 14.sp, color = StudentsNavy, fontWeight = FontWeight.Medium),
                                cursorBrush = SolidColor(StudentsPrimary),
                                modifier = Modifier.fillMaxWidth()
                            ) { inner ->
                                Box(Modifier.fillMaxWidth()) {
                                    if (searchQuery.isBlank()) Text("Search class or section", color = StudentsMuted, fontSize = 14.sp, fontWeight = FontWeight.Medium)
                                    inner()
                                }
                            }
                        }
                        if (picker.isLoading && picker.options.isEmpty()) {
                            Box(Modifier.fillMaxWidth().height(100.dp), contentAlignment = Alignment.Center) {
                                CircularProgressIndicator(modifier = Modifier.size(22.dp), strokeWidth = 2.dp, color = StudentsPrimary)
                            }
                        } else if (picker.errorMessage.isNotBlank() && picker.options.isEmpty()) {
                            Text(picker.errorMessage, color = StudentsDanger, fontSize = 14.sp, modifier = Modifier.padding(18.dp))
                        } else if (picker.options.isEmpty()) {
                            Text("No classes found", color = StudentsMuted, fontSize = 14.sp, fontWeight = FontWeight.Medium, modifier = Modifier.padding(18.dp))
                        } else {
                            LazyColumn(state = listState, modifier = Modifier.fillMaxWidth().heightIn(max = 235.dp)) {
                                items(picker.options, key = { it.id }) { option ->
                                    Box(
                                        Modifier.fillMaxWidth().clickable { onSelected(option); onDismissExpanded() }.padding(horizontal = 18.dp, vertical = 9.dp)
                                    ) {
                                        Column {
                                            Text("Class ${option.className}", color = StudentsNavy, fontSize = 14.sp, fontWeight = FontWeight.Medium)
                                            Text("Section ${option.sectionName}", color = StudentsMuted, fontSize = 12.sp, fontWeight = FontWeight.Medium)
                                        }
                                    }
                                }
                                if (picker.isLoadingMore) {
                                    item {
                                        Box(Modifier.fillMaxWidth().padding(10.dp), contentAlignment = Alignment.Center) {
                                            CircularProgressIndicator(modifier = Modifier.size(18.dp), strokeWidth = 2.dp, color = StudentsPrimary)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

private fun classSectionDropdownPopupPositionProvider(): PopupPositionProvider = object : PopupPositionProvider {
    override fun calculatePosition(
        anchorBounds: IntRect,
        windowSize: IntSize,
        layoutDirection: androidx.compose.ui.unit.LayoutDirection,
        popupContentSize: IntSize
    ): IntOffset {
        val x = anchorBounds.left.coerceIn(0, (windowSize.width - popupContentSize.width).coerceAtLeast(0))
        val belowY = anchorBounds.bottom + 8
        val aboveY = anchorBounds.top - popupContentSize.height - 8
        val y = if (belowY + popupContentSize.height <= windowSize.height) belowY else aboveY.coerceAtLeast(0)
        return IntOffset(x, y)
    }
}

@Composable
private fun StudentSubjectMultiSelectField(
    selectedCodes: List<String>,
    onSelectedCodesChange: (List<String>) -> Unit,
    subjectOptions: List<StudentSubjectOption> = emptyList(),
    error: String = "",
    onOpened: () -> Unit = {}
) {
    var searchQuery by remember { mutableStateOf("") }
    var expanded by remember { mutableStateOf(false) }
    var anchorSize by remember { mutableStateOf(IntSize.Zero) }
    val listState = rememberLazyListState()
    val options = subjectOptions
    val filtered = remember(searchQuery, options) {
        options.filter {
            it.code.contains(searchQuery, ignoreCase = true) || it.label.contains(searchQuery, ignoreCase = true)
        }
    }

    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
        Box(modifier = Modifier.onGloballyPositioned { anchorSize = it.size }) {
            Surface(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(58.dp)
                    .clickable {
                        if (!expanded) onOpened()
                        expanded = !expanded
                    },
                shape = RoundedCornerShape(8.dp),
                color = StudentsSurface,
                border = androidx.compose.foundation.BorderStroke(
                    1.dp,
                    if (expanded) StudentsPrimary else if (error.isNotBlank()) StudentsDanger else StudentsBorder
                )
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(horizontal = 16.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.search),
                        contentDescription = null,
                        tint = StudentsPrimary,
                        modifier = Modifier.size(22.dp)
                    )
                    Text(
                        text = "Search by subject code or name",
                        modifier = Modifier.weight(1f).padding(horizontal = 12.dp),
                        color = StudentsMuted,
                        fontSize = 14.sp,
                        fontWeight = FontWeight.Medium,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    Icon(
                        painter = painterResource(Res.drawable.chevron_down),
                        contentDescription = null,
                        tint = StudentsPrimary
                    )
                }
            }

            if (expanded) {
                Popup(
                    popupPositionProvider = classSectionDropdownPopupPositionProvider(),
                    properties = PopupProperties(focusable = true, dismissOnBackPress = true, dismissOnClickOutside = true),
                    onDismissRequest = { expanded = false }
                ) {
                    Surface(
                        modifier = Modifier.width(with(LocalDensity.current) { anchorSize.width.toDp() }),
                        shape = RoundedCornerShape(8.dp),
                        color = StudentsSurface,
                        shadowElevation = 8.dp
                    ) {
                        Column {
                            Row(
                                modifier = Modifier.fillMaxWidth().height(54.dp).padding(horizontal = 18.dp),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(10.dp)
                            ) {
                                Icon(painterResource(Res.drawable.search), contentDescription = null, tint = StudentsMuted, modifier = Modifier.size(22.dp))
                                BasicTextField(
                                    value = searchQuery,
                                    onValueChange = { searchQuery = it },
                                    singleLine = true,
                                    textStyle = TextStyle(fontSize = 14.sp, color = StudentsNavy, fontWeight = FontWeight.Medium),
                                    cursorBrush = SolidColor(StudentsPrimary),
                                    modifier = Modifier.fillMaxWidth()
                                ) { inner ->
                                    Box(Modifier.fillMaxWidth()) {
                                        if (searchQuery.isBlank()) Text("Search subject code or name", color = StudentsMuted, fontSize = 14.sp, fontWeight = FontWeight.Medium)
                                        inner()
                                    }
                                }
                            }
                            if (filtered.isEmpty()) {
                                Text("No subjects found", color = StudentsMuted, fontSize = 14.sp, fontWeight = FontWeight.Medium, modifier = Modifier.padding(18.dp))
                            } else {
                                LazyColumn(state = listState, modifier = Modifier.fillMaxWidth().heightIn(max = 235.dp)) {
                                    items(filtered, key = { it.code }) { option ->
                                        val selected = selectedCodes.contains(option.code)
                                        Row(
                                            modifier = Modifier.fillMaxWidth().clickable {
                                                onSelectedCodesChange(
                                                    if (selected) selectedCodes.filterNot { it == option.code } else selectedCodes + option.code
                                                )
                                            }.padding(horizontal = 18.dp, vertical = 10.dp),
                                            verticalAlignment = Alignment.CenterVertically,
                                            horizontalArrangement = Arrangement.SpaceBetween
                                        ) {
                                            Column {
                                                Text(option.code, color = StudentsNavy, fontSize = 14.sp, fontWeight = FontWeight.SemiBold)
                                                Text(option.label.removePrefix("${option.code} - "), color = StudentsMuted, fontSize = 12.sp, fontWeight = FontWeight.Medium)
                                            }
                                            Checkbox(
                                                checked = selected,
                                                onCheckedChange = null,
                                                colors = CheckboxDefaults.colors(
                                                    checkedColor = StudentsPrimary,
                                                    uncheckedColor = StudentsBorder
                                                )
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        val horizontalState = rememberScrollState()
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .horizontalScroll(horizontalState),
            horizontalArrangement = Arrangement.spacedBy(10.dp)
        ) {
        selectedCodes.forEach { code ->
            val option = options.firstOrNull { it.code == code }
            StudentChip(
                text = option?.code ?: code,
                onRemove = { onSelectedCodesChange(selectedCodes.filterNot { it == code }) }
            )
        }
    }
}
}

@Composable
private fun StudentChip(
    text: String,
    onRemove: () -> Unit
) {
    Row(
        modifier = Modifier
            .background(Color(0xFFEAF1FF), RoundedCornerShape(6.dp))
            .border(1.dp, Color(0xFFD1DDFB), RoundedCornerShape(6.dp))
            .padding(horizontal = 12.dp, vertical = 8.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Text(
            text = text,
            color = StudentsNavy,
            fontSize = 13.sp,
            fontWeight = FontWeight.Bold
        )
        Text(
            text = "×",
            color = StudentsNavy,
            fontSize = 13.sp,
            fontWeight = FontWeight.Bold,
            modifier = Modifier.clickable(onClick = onRemove)
        )
    }
}

@Composable
internal fun StudentFilterModal(
    open: Boolean,
    searchQuery: String,
    initialValues: StudentFilterValues,
    classOptions: List<String>,
    sectionOptionsByClass: Map<String, List<String>>,
    onClose: () -> Unit,
    onApply: (String, StudentFilterValues) -> Unit,
    onReset: () -> Unit
) {
    if (!open) return

    val bloodGroupOptions = rememberStudentLookupOptions("BLOOD_GROUP")
    var values by remember(initialValues) { mutableStateOf(initialValues) }
    var classExpanded by remember { mutableStateOf(false) }
    var sectionExpanded by remember { mutableStateOf(false) }
    var genderExpanded by remember { mutableStateOf(false) }
    var statusExpanded by remember { mutableStateOf(false) }
    var bloodGroupExpanded by remember { mutableStateOf(false) }

    LaunchedEffect(open, searchQuery, initialValues) {
        if (open) {
            values = initialValues
            classExpanded = false
            sectionExpanded = false
            genderExpanded = false
            statusExpanded = false
            bloodGroupExpanded = false
        }
    }

    AppDialogScaffold(
        onDismiss = onClose,
        size = AppDialogSize.Wide,
        colors = StudentsDialogColors,
        maxDialogHeight = 900.dp
    ) {
        AppDialogFormGrid(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            contentAlignment = Alignment.Center,
            compactBreakpoint = 920.dp
        ) {
            val compact = it
            val scrollState = rememberScrollState()

            Column(modifier = Modifier.fillMaxWidth()) {
                StudentFilterHeader(onClose = onClose)
                HorizontalDivider(color = StudentsBorder)
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f, fill = false)
                        .verticalScroll(scrollState)
                        .padding(horizontal = if (compact) 24.dp else 28.dp, vertical = 24.dp),
                    verticalArrangement = Arrangement.spacedBy(22.dp)
                ) {
                    StudentFilterClassSectionTextFields(
                        values = values,
                        compact = compact,
                        classOptions = classOptions,
                        sectionOptions = sectionOptionsByClass[values.className].orEmpty()
                            .ifEmpty { sectionOptionsByClass.values.flatten().distinct() },
                        classExpanded = classExpanded,
                        onClassToggle = { classExpanded = !classExpanded },
                        onClassDismiss = { classExpanded = false },
                        sectionExpanded = sectionExpanded,
                        onSectionToggle = { sectionExpanded = !sectionExpanded },
                        onSectionDismiss = { sectionExpanded = false },
                        onValuesChange = {
                            val classChanged = it.className != values.className
                            values = it
                            if (classChanged) {
                                sectionExpanded = false
                                if (it.section !in sectionOptionsByClass[it.className].orEmpty()) {
                                    values = it.copy(section = "")
                                }
                            }
                        }
                    )
                    StudentFilterGrid(
                        values = values,
                        genderExpanded = genderExpanded,
                        onGenderToggle = { genderExpanded = !genderExpanded },
                        onGenderDismiss = { genderExpanded = false },
                        statusExpanded = statusExpanded,
                        onStatusToggle = { statusExpanded = !statusExpanded },
                        onStatusDismiss = { statusExpanded = false },
                        bloodGroupExpanded = bloodGroupExpanded,
                        onBloodGroupToggle = { bloodGroupExpanded = !bloodGroupExpanded },
                        onBloodGroupDismiss = { bloodGroupExpanded = false },
                        onValuesChange = { values = it }
                    )

                    Row(horizontalArrangement = Arrangement.spacedBy(28.dp)) {
                        StudentFieldColumn(
                            label = "Subject Code / Subject",
                            required = false,
                            error = "",
                            modifier = Modifier.weight(1f)
                        ) {
                            StudentTextField(
                                value = values.subjectCodes.joinToString(", "),
                                onValueChange = { text ->
                                    values = values.copy(
                                        subjectCodes = text.split(",")
                                            .map { it.trim() }
                                            .filter { it.isNotBlank() }
                                    )
                                },
                                placeholder = "Enter subject code or subject"
                            )
                        }
                        StudentFieldColumn(
                            label = "Blood Group",
                            required = false,
                            error = "",
                            modifier = Modifier.weight(1f)
                        ) {
                            StudentDropdownField(
                                value = values.bloodGroupCode
                                    .takeIf { it.isNotBlank() }
                                    ?.let(::studentBloodGroupLabel)
                                    .orEmpty(),
                                placeholder = "Select Blood Group",
                                expanded = bloodGroupExpanded,
                                options = bloodGroupOptions.map { it.second },
                                onToggleExpanded = { bloodGroupExpanded = !bloodGroupExpanded },
                                onDismissExpanded = { bloodGroupExpanded = false },
                                onSelected = { selected ->
                                    val code = bloodGroupOptions.firstOrNull { it.second == selected }?.first.orEmpty()
                                    values = values.copy(bloodGroupCode = code)
                                }
                            )
                        }
                    }

                    Row(horizontalArrangement = Arrangement.spacedBy(28.dp)) {
                        StudentFieldColumn(
                            label = "Created Date From",
                            required = false,
                            error = "",
                            modifier = Modifier.weight(1f)
                        ) {
                            AppDialogDateField(
                                value = values.createdFrom,
                                onValueChange = { values = values.copy(createdFrom = it) },
                                placeholder = "DD MMM YYYY",
                                colors = StudentsDialogColors,
                                fieldHeight = 54.dp,
                                fontSize = 14.sp
                            )
                        }
                        StudentFieldColumn(
                            label = "Created Date To",
                            required = false,
                            error = "",
                            modifier = Modifier.weight(1f)
                        ) {
                            AppDialogDateField(
                                value = values.createdTo,
                                onValueChange = { values = values.copy(createdTo = it) },
                                placeholder = "DD MMM YYYY",
                                colors = StudentsDialogColors,
                                fieldHeight = 54.dp,
                                fontSize = 14.sp
                            )
                        }
                    }

                }

                HorizontalDivider(color = StudentsBorder)
                AppDialogFooter(
                    actions = listOf(
                        AppDialogFooterAction(
                            label = "Cancel",
                            onClick = onClose,
                            width = 204.dp
                        ),
                        AppDialogFooterAction(
                            label = "Reset",
                            onClick = {
                                values = StudentFilterValues()
                                onReset()
                            },
                            width = 188.dp
                        ),
                        AppDialogFooterAction(
                            label = "Apply",
                            onClick = { onApply(searchQuery, values) },
                            style = AppDialogActionStyle.Primary,
                            width = 264.dp
                        )
                    ),
                    colors = StudentsDialogColors,
                    contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 24.dp)
                )
            }
        }
    }
}

@Composable
private fun StudentFilterHeader(onClose: () -> Unit) {
    AppDialogHeader(
        title = "Filter Students",
        subtitle = "Narrow down the student list.",
        onClose = onClose,
        colors = StudentsDialogColors,
        icon = Res.drawable.filter,
        iconContentDescription = "Filter students"
    )
}

@Composable
private fun StudentFilterClassSectionTextFields(
    values: StudentFilterValues,
    compact: Boolean,
    classOptions: List<String>,
    sectionOptions: List<String>,
    classExpanded: Boolean,
    onClassToggle: () -> Unit,
    onClassDismiss: () -> Unit,
    sectionExpanded: Boolean,
    onSectionToggle: () -> Unit,
    onSectionDismiss: () -> Unit,
    onValuesChange: (StudentFilterValues) -> Unit
) {
    if (compact) {
        Column(verticalArrangement = Arrangement.spacedBy(18.dp)) {
            StudentFilterClassDropdown(values, classOptions, classExpanded, onClassToggle, onClassDismiss, onValuesChange)
            StudentFilterSectionDropdown(values, sectionOptions, sectionExpanded, onSectionToggle, onSectionDismiss, onValuesChange)
        }
    } else {
        Row(horizontalArrangement = Arrangement.spacedBy(28.dp)) {
            StudentFilterClassDropdown(values, classOptions, classExpanded, onClassToggle, onClassDismiss, onValuesChange, Modifier.weight(1f))
            StudentFilterSectionDropdown(values, sectionOptions, sectionExpanded, onSectionToggle, onSectionDismiss, onValuesChange, Modifier.weight(1f))
        }
    }
}

@Composable
private fun StudentFilterClassDropdown(
    values: StudentFilterValues,
    options: List<String>,
    expanded: Boolean,
    onToggle: () -> Unit,
    onDismiss: () -> Unit,
    onValuesChange: (StudentFilterValues) -> Unit,
    modifier: Modifier = Modifier
) {
    StudentFieldColumn(label = "Class", required = false, error = "", modifier = modifier) {
        StudentDropdownField(
            value = values.className,
            placeholder = "Select Class",
            expanded = expanded,
            options = options,
            onToggleExpanded = onToggle,
            onDismissExpanded = onDismiss,
            onSelected = { onValuesChange(values.copy(className = it, section = "")) }
        )
    }
}

@Composable
private fun StudentFilterSectionDropdown(
    values: StudentFilterValues,
    options: List<String>,
    expanded: Boolean,
    onToggle: () -> Unit,
    onDismiss: () -> Unit,
    onValuesChange: (StudentFilterValues) -> Unit,
    modifier: Modifier = Modifier
) {
    StudentFieldColumn(label = "Section", required = false, error = "", modifier = modifier) {
        StudentDropdownField(
            value = values.section,
            placeholder = "Select Section",
            expanded = expanded,
            options = options,
            onToggleExpanded = onToggle,
            onDismissExpanded = onDismiss,
            onSelected = { onValuesChange(values.copy(section = it)) }
        )
    }
}

@Composable
private fun StudentFilterClassSectionField(
    values: StudentFilterValues,
    classSectionPicker: StudentClassSectionPickerUi,
    classSectionExpanded: Boolean,
    onClassSectionToggle: () -> Unit,
    onClassSectionDismiss: () -> Unit,
    onClassSectionSearchChanged: (String) -> Unit,
    onClassSectionPageChanged: (Int) -> Unit,
    onClassSectionLoadMore: () -> Unit,
    onClassSectionOpened: () -> Unit,
    onValuesChange: (StudentFilterValues) -> Unit,
    modifier: Modifier = Modifier
) {
    StudentFieldColumn(
        label = "Class & Section",
        required = false,
        error = "",
        modifier = modifier
    ) {
        StudentClassSectionPickerField(
            value = values.className.takeIf { it.isNotBlank() }?.let { "$it - ${values.section}" }.orEmpty(),
            picker = classSectionPicker,
            expanded = classSectionExpanded,
            onToggleExpanded = onClassSectionToggle,
            onDismissExpanded = onClassSectionDismiss,
            onSearchChanged = onClassSectionSearchChanged,
            onPageChanged = onClassSectionPageChanged,
            onLoadMore = onClassSectionLoadMore,
            onOpened = onClassSectionOpened,
            onSelected = { option ->
                onValuesChange(values.copy(className = option.className, section = option.sectionName))
            }
        )
    }
}

@Composable
private fun StudentFilterGrid(
    values: StudentFilterValues,
    genderExpanded: Boolean,
    onGenderToggle: () -> Unit,
    onGenderDismiss: () -> Unit,
    statusExpanded: Boolean,
    onStatusToggle: () -> Unit,
    onStatusDismiss: () -> Unit,
    bloodGroupExpanded: Boolean,
    onBloodGroupToggle: () -> Unit,
    onBloodGroupDismiss: () -> Unit,
    onValuesChange: (StudentFilterValues) -> Unit
) {
    val genderOptions = rememberStudentLookupOptions("GENDER")
    val statusOptions = listOf(
        SchoolKeys.V_STATUS_ACTIVE to "Active",
        SchoolKeys.V_STATUS_INACTIVE to "Inactive"
    )
    val bloodGroupOptions = rememberStudentLookupOptions("BLOOD_GROUP")

    Row(horizontalArrangement = Arrangement.spacedBy(28.dp)) {
        StudentFieldColumn(
            label = "Gender",
            required = false,
            error = "",
            modifier = Modifier.weight(1f)
        ) {
            StudentDropdownField(
                value = values.genderCode
                    .takeIf { it.isNotBlank() }
                    ?.let(::studentGenderLabel)
                    .orEmpty(),
                placeholder = "Select Gender",
                expanded = genderExpanded,
                options = genderOptions.map { it.second },
                onToggleExpanded = onGenderToggle,
                onDismissExpanded = onGenderDismiss,
                onSelected = { selected ->
                    onValuesChange(values.copy(genderCode = genderOptions.firstOrNull { it.second == selected }?.first.orEmpty()))
                }
            )
        }
        StudentFieldColumn(
            label = "Status",
            required = false,
            error = "",
            modifier = Modifier.weight(1f)
        ) {
            StudentDropdownField(
                value = values.statusCode
                    .takeIf { it.isNotBlank() }
                    ?.let(::studentStatusLabel)
                    .orEmpty(),
                placeholder = "Select Status",
                expanded = statusExpanded,
                options = statusOptions.map { it.second },
                onToggleExpanded = onStatusToggle,
                onDismissExpanded = onStatusDismiss,
                onSelected = { selected ->
                    onValuesChange(values.copy(statusCode = statusOptions.firstOrNull { it.second == selected }?.first.orEmpty()))
                }
            )
        }
    }

}
